import React from "react";
import { Icon, ITextFieldProps, TextField } from "office-ui-fabric-react";

export const iconButtonStyles = {
  root: {
    color: 'rgb(204,204,204)',
    margin: '3px 7px 0px 0px',
    textAlign: 'right',
    selectors: {
      ':hover': {
        color: 'rgb(153, 153, 153)',
        cursor: 'pointer'
      }
    }
  },
};

const ClearableTextField: React.FC<ITextFieldProps> = ({ value, onChange, ...props }) => {
  const onPasteChange = (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (props?.type !== "Number") return;
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const sanitized = pastedText.replace(/[^0-9]/g, "");
    if (onChange) {
      onChange(
        { target: { id: props?.id, value: sanitized } } as React.ChangeEvent<HTMLInputElement>,
        sanitized
      );
    }
  };
    return (
        <TextField
            {...props}
            id={props?.id}
            value={value}
            onChange={onChange}
            title={value ? value : ''}
            onKeyDown={(e) => {
              if (props?.type === "Number") {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }
            }}
            onPaste={onPasteChange}
            onRenderSuffix={() =>
                value!==null && value!==undefined && value!=="" && !props.disabled && !props.multiline ? (
                    <Icon
                        iconName= "Cancel"
                        onClick={() => {
                          if (onChange) {
                            onChange({ target: {id: props?.id, value: "" } } as React.ChangeEvent<HTMLInputElement>, "");
                          }
                        }}
                        styles={iconButtonStyles}
                    />
                ) : null
            }
        />
    );
};

export default ClearableTextField; 